import axios from "axios";
import React, { useEffect, useContext, useState } from "react";
import AuthContext from "../context/userAuth.context";
import MyContext from "../context/MyContext";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import CloseIcon from "@mui/icons-material/Close";

import IconButton from "@mui/material/IconButton";
import DialogTitle from "@mui/material/DialogTitle";
import swal from "sweetalert";
import btnLoader from "../assets/btnLoader.svg";
import RecordView from "./RecordView";
import Swal from "sweetalert2";

function TTS({ show, onHide, isDone, setIsDone }) {
  const [ttsData, setTTSData] = useState([]);
  const [ttsUnavailable, setTtsUnavailable] = useState(false);
  const [languageList, setLanguageList] = useState([{ value: 0, text: "" }]);
  const [accentList, setAccentList] = useState([{ value: 0, text: "" }]);
  const { authenticationData, Access, getLink } = useContext(AuthContext);
  const [googleVoices, setgoogleVoices] = useState([]);
  const { clone, SoundsData, setSoundsData, setisTextInputOrAreaFocus } =
    useContext(MyContext);
  const [open, setOpen] = React.useState(false);
  const [showBtnLoader, setshowBtnLoader] = React.useState(false);
  const [voicelist, setVoicelist] = React.useState([]);
  const [showSettings, setshowSettings] = React.useState(true);
  const [selectedVoice, setSelectedVoice] = React.useState(null);
  const [isplaying, setisplaying] = React.useState(false);
  const [selectedVoicePath, setSelectedVoicePath] = React.useState(null);

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );
  useEffect(() => {
    getTTSData();
    //FillRegion("en-US");
  }, []);

  const getTTSData = () => {
    axios
      .get(authenticationData.ApiBaseURL + "/api/TTS/getAllTTSData")
      .then((response) => {
        const voices = (response.data && response.data.response) || [];
        setTTSData([...voices]);
        setTtsUnavailable(voices.length === 0);
        if (voices.length === 0 && response.data && response.data.error) console.log("Text to speech:", response.data.error, response.data.details || "");
      })
      .catch((error) => {
        // Before: an error here was unhandled (full-screen error in development, empty lists).
        console.log("Text to speech voices could not be loaded.", error);
        setTtsUnavailable(true);
      });
  };

  useEffect(() => {
    if (ttsData.length > 0) {
      if (show === true) {
        const mytimer1 = setInterval(() => {
          if (
            document.getElementById("tts_Language") &&
            document.getElementById("tts_Gender")
          ) {
            clearInterval(mytimer1);
            FillLanguage();
          }
        }, 10);
      } else if (show === undefined) {
        FillLanguage();
      }
    }
  }, [ttsData, show]);

  // useEffect(() => {
  //   if (languageList.length > 0) {
  //     if (show === true) {
  //       const mytimer = setInterval(() => {
  //         if (document.getElementById("tts_type")) {
  //           FillRegion();
  //           clearInterval(mytimer);
  //         }
  //       }, 10);
  //     } else if (show === undefined) {
  //       FillRegion();
  //     }
  //   }
  // }, [languageList, show]);

  const FillRegion = (value) => {
    var arr = [];
    arr = ttsData.filter((e) => e.languageCodes == value);
    arr = arr.filter(
      (e) => e.name.includes("Standard") || e.name.includes("Wavenet")
    );
    setgoogleVoices(arr);
  };

  // const FillRegion = () => {
  //   var a =
  //     document.getElementById("tts_Language").options[
  //       document.getElementById("tts_Language").selectedIndex
  //     ].text;
  //   var gender =
  //     document.getElementById("tts_Gender").options[
  //       document.getElementById("tts_Gender").selectedIndex
  //     ].text;

  //   if (ttsData.length > 0) {
  //     let arr = [];
  //     for (var x = 0; x < ttsData.length; x++) {
  //       var lang = ttsData[x].languageName;
  //       if (lang == a && ttsData[x].ssmlGender == gender) {
  //         if (
  //           arr.filter((e) => e.text === ttsData[x].languageCountry).length ===
  //           0
  //         ) {
  //           arr.push({
  //             value: ttsData[x].languageCodes[0].split("-")[1],
  //             text: ttsData[x].languageCountry,
  //           });
  //         }
  //       }
  //     }
  //     setAccentList([...arr]);
  //   }
  // };

  const FillLanguage = () => {
    // let val = document.getElementById("tts_type").value;
    if (ttsData.length > 0) {
      let arr = [];
      // var a = val;
      for (var x = 0; x < ttsData.length; x++) {
        var lang = ttsData[x].name.split("-")[2];

        if (
          arr.filter(
            (e) =>
              e.text ===
              ttsData[x].languageName +
                "-" +
                ttsData[x].languageCodes[0] +
                " (" +
                ttsData[x].languageCountry +
                ")"
          ).length === 0
        ) {
          arr.push({
            value: ttsData[x].languageCodes[0],
            text:
              ttsData[x].languageName +
              "-" +
              ttsData[x].languageCodes[0] +
              " (" +
              ttsData[x].languageCountry +
              ")",
          });
        }
      }
      arr.sort((a, b) => a.text.localeCompare(b.text));
      setLanguageList([...arr]);
    }
    FillRegion("en-US");
  };

  const Languagetranslate = () => {
    var to = document.getElementById("translation_text2").value;
    if (to != 0) {
      var data1 = document.getElementById("tts_text").value;
      translateHelper(data1, to);
    }
  };

  function translateHelper(text, To) {
    let formdata = new FormData();
    formdata.append("text", text);
    formdata.append("To", To);
    axios
      .post(authenticationData.ApiBaseURL + "/api/TTS/Translate", formdata)
      .then((response) => {
        document.getElementById("tts_text").value = response.data.response;
      });
  }

  const SearchVoices = () => {
    var fullGoogleVoiceName = document.getElementById("GoogleVoice").value;
    var text = document.getElementById("tts_text").value;
    let formdata = new FormData();
    if (fullGoogleVoiceName) {
      // format is "en-IN-Standar-Female"
      //console.log(fullGoogleVoiceName.split("-")[0]);
      //console.log(fullGoogleVoiceName.split("-")[1]);
      //console.log(fullGoogleVoiceName.split("-")[2]);
      //console.log(fullGoogleVoiceName.split("-")[4]);
      formdata.append("langCode", fullGoogleVoiceName.split("-")[0] + "-" + fullGoogleVoiceName.split("-")[1]);
      formdata.append("name", fullGoogleVoiceName.replace("-FEMALE","").replace("-MALE",""));
      formdata.append("gender", fullGoogleVoiceName.split("-")[4]);
      if (text) {
        formdata.append("text", text);
      } else {
        swal({
          title: "Please add some text in the text area.",
          icon: "error",
          backdrop: null,
        });
        return;
      }
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      setshowBtnLoader(true);
      axios
        .post(
          authenticationData.ApiBaseURL + "/api/TTS/TextToSpeech",
          formdata,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          setOpen(true);
          setVoicelist([...response.data.response]);
          setshowBtnLoader(false);
        })
        .catch((e) => {
          swal({
            title: "Something went wrong!",
            text: "Please report contact support for assistance.",
            icon: "error",
            backdrop: null,
          });
          setshowBtnLoader(false);
        });
    } else {
      swal({
        title: "Something went wrong!",
        text: "Please report contact support for assistance.",
        icon: "error",
        backdrop: null,
      });
    }

    // var type = document.getElementById("tts_type").value;
    // var text = document.getElementById("tts_text").value;
    // var lang = document.getElementById("tts_Language").value;
    // var gender = document.getElementById("tts_Gender").value;
    // var accent = document.getElementById("tts_accent").value;

    // var name = getNamesTTS(
    //   lang,
    //   document.getElementById("tts_Gender").options[
    //     document.getElementById("tts_Gender").selectedIndex
    //   ].text,
    //   type,
    //   accent
    // );

    // if (name.length != 0) {
    //   let formdata = new FormData();
    //   formdata.append("langCode", lang);
    //   name.forEach((element) => {
    //     formdata.append("name", element);
    //   });
    //   formdata.append("gender", gender);
    //   formdata.append("text", text);
    //   let authData = JSON.parse(
    //     localStorage.getItem("animation_studio_2.0_access_token")
    //   );
    //   setshowBtnLoader(true);
    //   axios
    //     .post(
    //       authenticationData.ApiBaseURL + "/api/TTS/TextToSpeech",
    //       formdata,
    //       {
    //         headers: {
    //           "Content-Type": "application/json",
    //           "Access-Control-Allow-Origin": "*",
    //           Authorization: "Bearer " + authData.access_token,
    //         },
    //       }
    //     )
    //     .then((response) => {
    //       setOpen(true);
    //       setVoicelist([...response.data.response]);
    //       setshowBtnLoader(false);
    //     })
    //     .catch((e) => {
    //       swal({
    //         title: "Something went wrong!",
    //         text: "Please report contact support for assistance.",
    //         icon: "error",
    //         backdrop: null,
    //       });
    //       setshowBtnLoader(false);
    //     });
    // }
  };

  function getNamesTTS(lang, gender, type, accent) {
    var a = [];
    for (var x = 0; x < ttsData.length; x++) {
      if (
        ttsData[x].languageCodes[0] == lang + "-" + accent &&
        ttsData[x].ssmlGender == gender &&
        ttsData[x].name.includes(type)
      ) {
        a.push(ttsData[x].name);
      }
    }
    return a;
  }

  const handleClose = () => {
    setOpen(false);
  };

  const selectDiv = (e, index) => {
    //alert(event.target.id);
    setSelectedVoicePath(e.target.id);
    setSelectedVoice(index);
  };
  const playAudio = (e) => {
    if (e.target.innerHTML == "Listen") {
      e.target.innerHTML = "Pause";
      e.target.classList.add("btn-yellow");
      e.target.classList.remove("btn-black");
      let element = e.target.previousElementSibling;
      element.play();
      element.addEventListener("ended", function () {
        e.target.innerHTML = "Listen";
        e.target.classList.add("btn-black");
        e.target.classList.remove("btn-yellow");
      });
    } else {
      e.target.innerHTML = "Listen";
      e.target.classList.add("btn-black");
      e.target.classList.remove("btn-yellow");
      let element = e.target.previousElementSibling;
      element.pause();
      element.currentTime = 0;
    }
  };
  useEffect(() => {
    if (selectedVoicePath != null) UploadToMedia();
  }, [selectedVoicePath]);

  const UploadToMedia = () => {
    var formdata = new FormData();
    formdata.append("TTSpath", selectedVoicePath);

    axios
      .post(
        authenticationData.ApiBaseURL + "/api/TTS/UploadUserTTS",
        formdata,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        setOpen(false);
        const DataArray = response.data.result;
        let array = clone(SoundsData);
        array.userData = DataArray;
        setSoundsData(array);
        // debugger
        // swal.fire({
        //   title: "Excellent",
        //   text: "TTS uploaded Successfully...",
        //   icon: "success",
        //   backdrop: null,
        // });

        swal({
          title: "Excellent",
          text: "TTS uploaded Successfully...",
          icon: "success",
          backdrop: null,
        });
      })
      .catch((excetion) => {
        setOpen(false);
        swal({
          title: "Failed",
          text: "Unable to Upload TTS. Please Try Again",
          icon: "error",
          backdrop: null,
        });
      });
  };

  return (
    <>
      {show === undefined ? (
        <>
          <div class="TextToSpeechTab ">
            <div style={{ padding: "1px" }}>
              {/* <div style={{ marginBottom: "15px" }}>
                <label class="ttsLabels">Template Scripts</label>
                <select className="customInput mb-1 " id="scriptList">
                  <option value="0">Custom</option>
                </select>
              </div> */}
              <textarea
                cols="30"
                placeholder="Write your Text Here..."
                rows="4"
                class="customInput"
                id="tts_text"
                onFocus={() => setisTextInputOrAreaFocus(true)}
                onBlur={() => setisTextInputOrAreaFocus(false)}
              ></textarea>
              <div
                style={{ marginBottom: "5px", width: "100%", display: "flex" }}
              >
                {/* <label class="whiteText">Text Translation : </label> */}
                {/* {showSettings && (
                  <div>
                    <button
                      class="btn btn-sm btn-black"
                      style={{
                        padding: "5px",
                        fontSize: "10px",
                        float: "right",
                      }}
                      onClick={() => setshowSettings(false)}
                    >
                      Hide Settings
                    </button>
                  </div>
                )} */}

                {!showSettings && (
                  <div>
                    <button
                      class="btn btn-sm btn-grey"
                      style={{
                        padding: "5px",
                        fontSize: "10px",
                        float: "right",
                      }}
                      onClick={() => setshowSettings(true)}
                    >
                      More Settings
                    </button>
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    flex: "1",
                    justifyContent: "flex-end",
                  }}
                >
                  <select
                    class="customInputSmall"
                    style={{
                      width: "80px",
                      float: "right",
                      marginRight: "5px",
                    }}
                    id="translation_text2"
                  >
                    <option value="af">Afrikaans</option>
                    <option value="ar">Arabic</option>
                    <option value="bn">Bangla</option>
                    <option value="bs">Bosnian (Latin)</option>
                    <option value="bg">Bulgarian</option>
                    <option value="yue">Cantonese (Traditional)</option>
                    <option value="ca">Catalan</option>
                    <option value="zh-Hant">Chinese (Traditional)</option>
                    <option value="hr">Croatian</option>
                    <option value="cs">Czech</option>
                    <option value="da">Danish</option>
                    <option value="nl">Dutch</option>
                    <option value="en" selected>
                      English
                    </option>
                    <option value="et">Estonian</option>
                    <option value="fj">Fijian</option>
                    <option value="fil">Filipino</option>
                    <option value="fi">Finnish</option>
                    <option value="fr">French</option>
                    <option value="de">German</option>
                    <option value="el">Greek</option>
                    <option value="ht">Haitian Creole</option>
                    <option value="he">Hebrew</option>
                    <option value="hi">Hindi</option>
                    <option value="mww">Hmong Daw</option>
                    <option value="hu">Hungarian</option>
                    <option value="is">Icelandic</option>
                    <option value="id">Indonesian</option>
                    <option value="it">Italian</option>
                    <option value="ja">Japanese</option>
                    <option value="sw">Kiswahili</option>
                    <option value="tlh">Klingon</option>
                    <option value="ko">Korean</option>
                    <option value="lv">Latvian</option>
                    <option value="lt">Lithuanian</option>
                    <option value="mg">Malagasy</option>
                    <option value="ms">Malay</option>
                    <option value="mt">Maltese</option>
                    <option value="nb">Norwegian</option>
                    <option value="fa">Persian</option>
                    <option value="pl">Polish</option>
                    <option value="pt">Portuguese</option>
                    <option value="otq">Queretaro Otomi</option>
                    <option value="ro">Romanian</option>
                    <option value="ru">Russian</option>
                    <option value="sm">Samoan</option>
                    <option value="sr-Cyrl">Serbian (Cyrillic)</option>
                    <option value="sr-Latn">Serbian (Latin)</option>
                    <option value="sk">Slovak</option>
                    <option value="sl">Slovenian</option>
                    <option value="es">Spanish</option>
                    <option value="sv">Swedish</option>
                    <option value="ty">Tahitian</option>
                    <option value="ta">Tamil</option>
                    <option value="te">Telugu</option>
                    <option value="th">Thai</option>
                    <option value="to">Tongan</option>
                    <option value="tr">Turkish</option>
                    <option value="uk">Ukrainian</option>
                    <option value="ur">Urdu</option>
                    <option value="vi">Vietnamese</option>
                    <option value="cy">Welsh</option>
                    <option value="yua">Yucatec Maya</option>
                  </select>

                  <button
                    class="btn btn-sm btn-black"
                    style={{ padding: "5px", fontSize: "10px", float: "right" }}
                    onClick={Languagetranslate}
                  >
                    Translate
                  </button>
                </div>
              </div>

              <div
                className="moreSettings"
                style={{ display: showSettings ? "block" : "block" }}
              >
                <div className="d-flex" style={{ marginTop: "10px" }}>
                  {/* <div style={{ marginRight: "15px" }}>
                    <label class="ttsLabels">Voice Type : </label>

                    <select
                      onChange={(e) => FillLanguage(e)}
                      class="customInputSmall"
                      id="tts_type"
                    >
                      <option value="Wavenet">Wave</option>
                      <option value="Standard">Standard</option>
                    </select>
                  </div> */}
                  <div>
                    <label class="ttsLabels">Speech Voice Language: </label>

                    <select
                      onChange={(e) => FillRegion(e.target.value)}
                      class="customInputSmall "
                      id="tts_Language"
                    >
                      {languageList.map((language) =>
                        language.value === "en-US" ? (
                          <option value={language.value} selected>
                            {language.text}
                          </option>
                        ) : (
                          <option value={language.value}>
                            {language.text}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>
                <div className="flex-col gap8" style={{ marginTop: "10px" }}>
                  <label class="ttsLabels">Select Voice: </label>
                  <select
                    className="customInputSmall noShadow"
                    style={{ width: "150px" }}
                    id="GoogleVoice"
                  >
                    {googleVoices.length > 0 &&
                      googleVoices.map((voice) => (
                        <option value={voice.name + "-" + voice.ssmlGender}>
                          {voice.name.replace(voice.languageCodes+"-","") + "-" + voice.ssmlGender}
                        </option>
                      ))}
                  </select>
                  {/* <label class="ttsLabels">Gender: </label>

                    <select class="customInputSmall noShadow" id="tts_Gender">
                      <option value="1" text="MALE">
                        MALE
                      </option>
                      <option value="2" text="FEMALE">
                        FEMALE
                      </option>
                    </select> */}

                  {/* <div>
                    <label class="ttsLabels">Accent: </label>

                    <select class="customInputSmall noShadow" id="tts_accent">
                      {accentList.map((fruit) =>
                        fruit.text == "United States" ? (
                          <option selected value={fruit.value}>
                            {fruit.text}
                          </option>
                        ) : (
                          <option value={fruit.value}>{fruit.text}</option>
                        )
                      )}
                    </select>
                  </div> */}
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                {ttsUnavailable && (
                  <p style={{ fontSize: "12px", color: "#c0392b", marginBottom: "8px" }}>
                    Text to speech is not available right now. Please try again later.
                  </p>
                )}
                <button
                  class="btn btn-blue  btn-sm"
                  style={{ width: "100%" }}
                  onClick={SearchVoices}
                >
                  Generate Voiceover
                  {showBtnLoader && (
                    <img
                      style={{ width: "20px", marginLeft: "20px" }}
                      src={btnLoader}
                    />
                  )}
                </button>
              </div>
              {/* <div style={{marginTop:"10px",borderRadius:"120px"}}>
              <button
                  class="btn btn-blue  btn-sm"
                  style={{ width: "100%" }}
                  onClick={(e)=> {setIsDone(true);}}
                >
                  Record Voice
                </button>

                {isDone &&
                <RecordView  style={{ marginTop: "20px",borderRadius:"120px" }}/>
                }
              </div> */}
            </div>
          </div>

          <div>
            <Dialog fullWidth open={open} onClose={handleClose}>
              <div style={{ zIndex: "3001" }}>
                <DialogTitle>
                  <div>Your Text to Speech Audios </div>
                  <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {voicelist.map((fruit, index) => (
                      <>
                        <div
                          id={fruit}
                          class={
                            selectedVoice == index
                              ? "AudioDiv ActiveVoice"
                              : "AudioDiv"
                          }
                        >
                          <div className="audioIcon">
                            <span
                              class="material-icons"
                              style={{ color: "white", fontSize: "31px" }}
                            >
                              audio_file
                            </span>
                          </div>
                          <a
                            style={{ display: "none" }}
                            id={fruit}
                            target="_blank"
                            onClick={(e) => selectDiv(e, index)}
                            href={authenticationData.ApiBaseURL + "/" + fruit}
                          >
                            <i
                              id={fruit}
                              onClick={(e) => selectDiv(e, index)}
                              class="fas fa-file-audio fa-2x AudioDivIcon"
                            ></i>
                          </a>

                          <div className="audioLabel">
                            {
                              document.getElementById("GoogleVoice").options[
                                document.getElementById("GoogleVoice")
                                  .selectedIndex
                              ].text
                            }
                            {/* <br></br>
                            <span>
                              {
                                document.getElementById("tts_Gender").options[
                                  document.getElementById("tts_Gender")
                                    .selectedIndex
                                ].text
                              }
                              -{index + 1}
                            </span> */}
                          </div>

                          <div className="audioPlayWrapper">
                            <div className="audioPlayBtnInsider">
                              <audio controls style={{ display: "none" }}>
                                <source
                                  src={
                                    authenticationData.ApiBaseURL + "/" + fruit
                                  }
                                  type="audio/ogg"
                                />
                                Your browser does not support the audio tag.
                              </audio>

                              <button
                                onClick={(e) => playAudio(e)}
                                class="btn btn-small btn-black"
                                style={{ marginRight: "5px" }}
                              >
                                Listen
                              </button>

                              {/* <button
                                onClick={(e) => playAudio(e)}
                                class="btn btn-small btn-yellow"
                                style={{ marginRight: "5px" }}
                              >
                                Pause
                              </button>
                           */}

                              <button
                                id={fruit}
                                class="btn btn-small btn-blue"
                                onClick={(e) => selectDiv(e, index)}
                              >
                                Add to media
                              </button>
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </DialogContent>

                <DialogActions>
                  {/* <button type="button" class="btn btn-primary" id="list_audio">
              Listen Audio
            </button> */}

                  {/* <button
                  type="button"
                  onClick={UploadToMedia}
                  class="btn btn-primary"
                >
                  Add to Uploads
                </button>

                <button
                  onClick={handleClose}
                  type="button"
                  class="btn btn-primary"
                >
                  Close
                </button> */}
                </DialogActions>
              </div>
            </Dialog>
          </div>
        </>
      ) : (
        <>
          <Dialog
            fullWidth={true}
            maxWidth={"md"}
            open={show}
            onClose={() => onHide(false)}
            style={{ zIndex: 9999 }}
          >
            <DialogTitle>Your Text to Speech Audios </DialogTitle>
            <DialogContent>
              <div class="TextToSpeechTab scrollbar style-6">
                <div style={{ padding: "1px" }}>
                  <div style={{ marginBottom: "15px" }}>
                    <label class=" d-block" style={{ color: "black" }}>
                      Template Scripts{" "}
                    </label>
                    <select
                      className="form-control noShadow"
                      style={{ width: 300 }}
                      id="scriptList"
                    >
                      <option value="0">Custom</option>
                    </select>
                  </div>
                  <textarea
                    cols="30"
                    placeholder="Write your Text Here..."
                    rows="4"
                    class="noShadow"
                    style={{
                      borderRadius: "5px",
                      width: "94%",
                      background: "white",
                      border: "#525252",
                      color: "black",
                      padding: "5px",
                    }}
                    id="tts_text"
                    onFocus={() => setisTextInputOrAreaFocus(true)}
                    onBlur={() => setisTextInputOrAreaFocus(false)}
                  ></textarea>
                  <div style={{ marginBottom: "10px" }}>
                    <label class="whiteText">Text Translation : </label>
                    <select
                      class="form-control noShadow"
                      style={{
                        width: "150px",
                        marginTop: "10px",
                        display: "inline-block",
                        background: "white",
                        border: "none",
                        color: "black",
                      }}
                      id="translation_text2"
                    >
                      <option value="0" selected>
                        Language
                      </option>
                      <option value="af">Afrikaans</option>
                      <option value="ar">Arabic</option>
                      <option value="bn">Bangla</option>
                      <option value="bs">Bosnian (Latin)</option>
                      <option value="bg">Bulgarian</option>
                      <option value="yue">Cantonese (Traditional)</option>
                      <option value="ca">Catalan</option>
                      <option value="zh-Hant">Chinese (Traditional)</option>
                      <option value="hr">Croatian</option>
                      <option value="cs">Czech</option>
                      <option value="da">Danish</option>
                      <option value="nl">Dutch</option>
                      <option value="en">English</option>
                      <option value="et">Estonian</option>
                      <option value="fj">Fijian</option>
                      <option value="fil">Filipino</option>
                      <option value="fi">Finnish</option>
                      <option value="fr">French</option>
                      <option value="de">German</option>
                      <option value="el">Greek</option>
                      <option value="ht">Haitian Creole</option>
                      <option value="he">Hebrew</option>
                      <option value="hi">Hindi</option>
                      <option value="mww">Hmong Daw</option>
                      <option value="hu">Hungarian</option>
                      <option value="is">Icelandic</option>
                      <option value="id">Indonesian</option>
                      <option value="it">Italian</option>
                      <option value="ja">Japanese</option>
                      <option value="sw">Kiswahili</option>
                      <option value="tlh">Klingon</option>
                      <option value="ko">Korean</option>
                      <option value="lv">Latvian</option>
                      <option value="lt">Lithuanian</option>
                      <option value="mg">Malagasy</option>
                      <option value="ms">Malay</option>
                      <option value="mt">Maltese</option>
                      <option value="nb">Norwegian</option>
                      <option value="fa">Persian</option>
                      <option value="pl">Polish</option>
                      <option value="pt">Portuguese</option>
                      <option value="otq">Queretaro Otomi</option>
                      <option value="ro">Romanian</option>
                      <option value="ru">Russian</option>
                      <option value="sm">Samoan</option>
                      <option value="sr-Cyrl">Serbian (Cyrillic)</option>
                      <option value="sr-Latn">Serbian (Latin)</option>
                      <option value="sk">Slovak</option>
                      <option value="sl">Slovenian</option>
                      <option value="es">Spanish</option>
                      <option value="sv">Swedish</option>
                      <option value="ty">Tahitian</option>
                      <option value="ta">Tamil</option>
                      <option value="te">Telugu</option>
                      <option value="th">Thai</option>
                      <option value="to">Tongan</option>
                      <option value="tr">Turkish</option>
                      <option value="uk">Ukrainian</option>
                      <option value="ur">Urdu</option>
                      <option value="vi">Vietnamese</option>
                      <option value="cy">Welsh</option>
                      <option value="yua">Yucatec Maya</option>
                    </select>
                    <button
                      class="btn btn-danger  btn-sm"
                      onClick={Languagetranslate}
                    >
                      Translate
                    </button>
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <label class="whiteText">Voice Type : </label>
                    <select
                      onChange={(e) => FillLanguage(e)}
                      class="form-control noShadow"
                      id="tts_type"
                    >
                      <option value="Wavenet">Wave</option>
                      <option value="Standard">Standard</option>
                    </select>
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <label class="whiteText">Voice Language: </label>
                    <select
                      onChange={FillRegion}
                      class="form-control noShadow"
                      style={{
                        width: "150px",
                        marginTop: "10px",
                        display: "inline-block",
                        background: "white",
                        border: "none",
                        color: "black",
                      }}
                      id="tts_Language"
                    >
                      {languageList.map((fruit) => (
                        <option value={fruit.value}>{fruit.text}</option>
                      ))}
                    </select>
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <div style={{ marginTop: "10px" }}>
                      {/* <label class="whiteText">Select Voice: </label>
                      <select
                        class="form-control noShadow"
                        style={{
                          width: "150px",
                          marginTop: "10px",
                          display: "inline-block",
                          background: "white",
                          border: "none",
                          color: "black",
                        }}
                        id="tts_Gender"
                      >
                        {googleVoices.length > 0 &&
                          googleVoices.map((voice) => (
                            <option value={voice.name}>{voice.name}</option>
                          ))}
                      </select> */}
                    </div>
                    {/* <label class="whiteText">Gender: </label>
                    <select
                      class="form-control noShadow"
                      style={{
                        width: "150px",
                        marginTop: "10px",
                        display: "inline-block",
                        background: "white",
                        border: "none",
                        color: "black",
                      }}
                      id="tts_Gender"
                    >
                      <option value="1" text="MALE">
                        MALE
                      </option>
                      <option value="2" text="FEMALE">
                        FEMALE
                      </option>
                    </select> */}
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <label class="whiteText">Accent: </label>
                    <select
                      class="form-control noShadow"
                      style={{
                        width: "150px",
                        marginTop: "10px",
                        display: "inline-block",
                        background: "white",
                        border: "none",
                        color: "black",
                      }}
                      id="tts_accent"
                    >
                      {accentList.map((fruit) => (
                        <option value={fruit.value}>{fruit.text}</option>
                      ))}
                    </select>
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <button
                      class="btn btn-success  btn-sm"
                      onClick={SearchVoices}
                    >
                      Search Voices
                    </button>
                  </div>
                </div>
              </div>
            </DialogContent>

            <DialogActions></DialogActions>
          </Dialog>

          <div>
            <Dialog open={open} onClose={handleClose} style={{ zIndex: 99999 }}>
              <DialogTitle>Your Text to Speech Audios </DialogTitle>
              <DialogContent>
                <div style={{ display: "flex" }}>
                  {voicelist.map((fruit, index) => (
                    <>
                      <div
                        id={fruit}
                        class={
                          selectedVoice == index
                            ? "AudioDiv ActiveVoice"
                            : "AudioDiv"
                        }
                        onClick={(e) => selectDiv(e, index)}
                      >
                        <a
                          id={fruit}
                          target="_blank"
                          onClick={(e) => selectDiv(e, index)}
                          href={authenticationData.ApiBaseURL + "/" + fruit}
                        >
                          <i
                            id={fruit}
                            onClick={(e) => selectDiv(e, index)}
                            class="fas fa-file-audio fa-2x AudioDivIcon"
                          ></i>
                        </a>
                      </div>
                      <div style={{ fontSize: 10 }}>
                        {
                          document.getElementById("tts_accent").options[
                            document.getElementById("tts_accent").selectedIndex
                          ].text
                        }
                        -
                        {
                          document.getElementById("tts_Gender").options[
                            document.getElementById("tts_Gender").selectedIndex
                          ].text
                        }
                        -{index + 1}
                      </div>
                    </>
                  ))}
                </div>
              </DialogContent>

              <DialogActions>
                <button
                  type="button"
                  onClick={UploadToMedia}
                  class="btn btn-primary"
                >
                  Add to Uploads
                </button>

                <button
                  onClick={handleClose}
                  type="button"
                  class="btn btn-primary"
                >
                  Close
                </button>
              </DialogActions>
            </Dialog>
          </div>
        </>
      )}
    </>
  );
}

export default TTS;
